/* eslint-disable react/no-unescaped-entities */
import React, { ReactNode, Fragment } from 'react'
import { Link } from 'react-router-dom'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import { Typography, Grid } from '@material-ui/core'
import Filters from '../containers/dailyMonitoring/details/filters/Index'
import Button from '@material-ui/core/Button'

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(2)
  },
  root: {
    '& > * + *': {
      marginLeft: theme.spacing(2)
    }
  },
  primary: {
    color: theme.palette.primary.light,
    textDecoration: 'none'
  },
  secondary: {
    color: theme.palette.secondary.light,
    textDecoration: 'none'
  }
}))

const ColorButtonActive = withStyles(() => ({
  root: {
    color: '#FFF',
    backgroundColor: '#043c61',
    borderColor: 'transparent',

    '&:hover': {
      backgroundColor: '#0a5180'
    }
  }
}))(Button)

const ColorButton = withStyles(() => ({
  root: {
    color: '#3f7cc2',
    borderColor: '#85c8e7',

    '&:hover': {
      backgroundColor: '#043c61',
      color: '#FFF',
      borderColor: 'transparent'
    }
  }
}))(Button)

type Props = {
  children: ReactNode
}

export default function DailyMonitoringTemplate ({
  children
}: Props): JSX.Element {
  const classes = useStyles()
  const getActualUrl = window.location.pathname

  const path = {
    principal: '/monitoramento-diario/detalhe-principal',
    cancelados: '/monitoramento-diario/detalhe-cancelados',
    resumo: '/monitoramento-diario/detalhe-resumo',
    shoppingCart: '/monitoramento-diario/cesta-simultanea'
  }

  return (
    <Fragment>
      <Grid container spacing={1} justifyContent="space-between" className={classes.container}>
        <Filters />
        <Grid item xs={12}>
          <Typography className={classes.root}>
            <Link to={path.principal} className={classes.secondary}>
              {getActualUrl === path.principal
                ? (
                <ColorButtonActive variant="outlined" size="small">
                  Principal
                </ColorButtonActive>
                  )
                : (
                <ColorButton variant="outlined" size="small">
                  Principal
                </ColorButton>
                  )}
            </Link>
            <Link to={path.cancelados} className={classes.primary}>
              {getActualUrl === path.cancelados
                ? (
                <ColorButtonActive variant="outlined" size="small">
                  Cancelados
                </ColorButtonActive>
                  )
                : (
                <ColorButton variant="outlined" size="small">
                  Cancelados
                </ColorButton>
                  )}
            </Link>
            <Link to={path.resumo} className={classes.primary}>
              {getActualUrl === path.resumo
                ? (
                <ColorButtonActive variant="outlined" size="small">
                  Resumo
                </ColorButtonActive>
                  )
                : (
                <ColorButton variant="outlined" size="small">
                  Resumo
                </ColorButton>
                  )}
            </Link>
            <Link to={path.shoppingCart} className={classes.primary}>
              {getActualUrl === path.shoppingCart
                ? (
                <ColorButtonActive variant="outlined" size="small">
                  CESTA SIMULTÂNEA
                </ColorButtonActive>
                  )
                : (
                <ColorButton variant="outlined" size="small">
                  CESTA SIMULTÂNEA
                </ColorButton>
                  )}
            </Link>
          </Typography>
        </Grid>
      </Grid>
      {children}
    </Fragment>
  )
}
